import { render, staticRenderFns } from "./PreorderSettingForm.vue?vue&type=template&id=4c8e40bc&scoped=true&"
import script from "./PreorderSettingForm.vue?vue&type=script&lang=js&"
export * from "./PreorderSettingForm.vue?vue&type=script&lang=js&"
import style0 from "./PreorderSettingForm.vue?vue&type=style&index=0&id=4c8e40bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e40bc",
  null
  
)

export default component.exports